import type { Asset } from '@schibsted-svp/svp-api-types';
import { hasEditorialLink, hasSponsorData } from './assetHelpers';
import { getAssetMetadata } from '../../../utils/player/asset';
import { getCategoryShortPath } from '../../../utils/player/category';

type LinkData =
  | {
      type: 'sponsored';
      url: string;
      text: string;
      sponsor: string;
    }
  | {
      type: 'editorial';
      url: string;
      text: string;
    };

export function getOverlayData(asset: Asset): LinkData | undefined {
  const { sponsoredLinkUrl, sponsoredLinkText } = getAssetMetadata(asset);
  if (hasSponsorData(asset) && sponsoredLinkUrl && sponsoredLinkText) {
    return {
      type: 'sponsored',
      text: sponsoredLinkText,
      url: sponsoredLinkUrl,
      sponsor: getCategoryShortPath(asset.category)!,
    };
  }

  if (hasEditorialLink(asset)) {
    const { editorialLinkText, editorialLinkUrl } = getAssetMetadata(asset);
    return {
      type: 'editorial',
      text: editorialLinkText,
      url: editorialLinkUrl,
    };
  }
}
